package one.healthium.ui.compose.components

import androidx.compose.runtime.Composable

@Composable
actual fun MakeStyleSystemBars() {
}